<template>
    <v-container class="form-container">
        <page-header title="About Us" subtitle="Content of the About Us page on the website and app">
            <v-btn color="primary" depressed :loading="saving" :disabled="loadingEntity" @click="onSubmit">
                <v-icon left>mdi-content-save-outline</v-icon>Save
            </v-btn>
        </page-header>
        <v-card outlined :loading="loadingEntity">
            <v-card-text>
                <editor
                    v-model="aboutUs.description"
                    :api-key="tinymceApiKey"
                    :init="editorInit"
                />
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
    import aboutUsService from '@/services/about-us-service'
    import Editor from '@tinymce/tinymce-vue'
    import PageHeader from '@/components/PageHeader'

    export default {
        name: 'AboutUsRoute',
        components: { Editor, PageHeader },
        data: () => {
            return {
                saving: false,
                loadingEntity: true,
                exists: false,
                tinymceApiKey: process.env.VUE_APP_TINYMCE_API_KEY,
                aboutUs: {
                    description: ''
                },
                editorInit: {
                    menubar: false,
                    statusbar: true,
                    height: 560,
                    resize: true,
                    entity_encoding: 'raw',
                    valid_elements: '*[*]',
                    extended_valid_elements: 'script[src|async|defer|type|charset],style[type|media],iframe[src|style|width|height|scrolling|marginwidth|marginheight|frameborder|allowfullscreen],svg[*],path[*]',
                    plugins: [
                        'advlist autolink lists link image charmap print preview anchor',
                        'searchreplace visualblocks fullscreen emoticons code',
                        'insertdatetime media table paste help wordcount'
                    ],
                    fontsize_formats: '8px 10px 12px 14px 18px 24px 36px',
                    toolbar: 'undo redo | code | styleselect | forecolor | bold italic | fontselect fontsizeselect | emoticons | alignleft aligncenter alignright alignjustify | numlist bullist | outdent indent | link image | media | fullscreen'
                }
            }
        },
        created() {
            aboutUsService.getAboutUs().then(resp => {
                const existing = resp.data.data[0]
                if (existing) {
                    this.aboutUs.description = existing.description || ''
                    this.exists = true
                }
            }).catch(error => {
                this.$notify.error(error, 'Could not load the About Us content')
            }).finally(() => {
                this.loadingEntity = false
            })
        },
        methods: {
            onSubmit() {
                this.saving = true
                const payload = { description: this.aboutUs.description }
                const request = this.exists ? aboutUsService.editAboutUs(payload) : aboutUsService.createAboutUs(payload)
                request.then(() => {
                    this.exists = true
                    this.$notify.success('About Us saved')
                }).catch(error => {
                    this.$notify.error(error, 'Could not save the About Us content')
                }).finally(() => {
                    this.saving = false
                })
            }
        }
    }
</script>
